import { toast } from "react-toastify";
import {
  create_preliminar_element,
  update_preliminar_element,
} from "../../../api/layers/ApiLayerAsbestos";
import { TeledetectionButtonTool } from "../../../components/CustomComponents/LayerTools/TeledeteccionTool/TeledeteccionTool";
import { WmsLayer } from "../WmsLayer";
import { AsbestosFeatureLayer } from "./Components/AsbestosFeatureLayer";
// import { TeledetectionButtonTool } from "./";
import { FilterAsbestosInventory } from "./Components/FilterAsbestosInventory";
import i18n from "../../../utils/i18n";
import { findLayerById } from "../../../services/MapCore/LayerGroupService";
import { translations } from "../../../utils/i18n/translations";
import { UndoButton } from "../../layer_groups/asbestos/AsbestosLayerGroup";
import {
  createNewFeatureLayerToMap,
  enableEditingOnFeature,
} from "../../../services/MapCore/MapService";
import { Confirm } from "notiflix";
import PentagonOutlinedIcon from "@mui/icons-material/PentagonOutlined";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import CropSquareIcon from "@mui/icons-material/CropSquare";
class AsbestosInventoryLayer extends WmsLayer {
  constructor(layer_data, layer_group_id) {
    super(layer_data, layer_group_id);
    this.has_filter = true;
    this.getFilter = () => (
      <FilterAsbestosInventory
        callback={this.callback_change_filter}
        filters={this.filters}
      />
    );
    this.id = this.id.replace(
      layer_data.uuid,
      `asbestos-inventory-${layer_data.uuid}`
    );
  }

  getLayerTools(i18n) {
    const tools = super.getLayerTools(i18n);

    tools.push({
      button: <TeledetectionButtonTool key={this.id} layer={this} />,
    });

    return tools;
  }

  createInventoryPoint = async ({ coordinates, map, data }) => {
    const toast_id_creating_new_element = toast.info(
      `${translations[i18n.language].creating_new_element}...`,
      {
        hideProgressBar: false,
        loading: true,
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );

    try {
      const payload = { ...data };
      const geom = {
        type: "Feature",
        geometry: {
          coordinates: coordinates,
          type: "Point",
        },
      };

      payload["geometry"] = geom;
      payload["inspection_type"] = "PRELIMINAR";
      payload["element_type"] = "CUBIERTA";

      const newElement = await create_preliminar_element(this.uuid, payload);

      const layer_g = findLayerById(map, this.id);

      layer_g.getSource()?.updateParams({ t: Date.now() });

      toast.update(toast_id_creating_new_element, {
        render: translations[i18n.language].element_created_successfully,
        type: "success",
        isLoading: false,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: (
          <UndoButton
            item_uuid={newElement.uuid}
            layerUuid={this.uuid}
            map={map}
          />
        ),
      });
    } catch (err) {
      console.error("Error en la petición", err);
      toast.update(toast_id_creating_new_element, {
        render: translations[i18n.language].element_creating_error,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  callback_change_filter = (new_filters) => {
    // document.addEventListener("update-filter-"+layerGroup.id,loadFeatures() )
    console.log("Cambiando filtros", this.layer);
    this.filters = new_filters;
    const new_source = this.createSource();

    this.layer.setSource(new_source);
    this.layer.getSource()?.updateParams({ t: Date.now() });
    console.log("Cambiando source", this.layer);
  };

  getFeatureComponent(feature) {
    return <AsbestosFeatureLayer feature={feature} key={this.id} />;
  }

  getActionsOnRightClick = ({
    event,
    map,
    setEditedGeometry,
    modeOptions,
    setModeOptions,
  }) => {
    return [
      {
        label: "create_inventory_element",
        items: [
          {
            label: "point",

            action: () =>
              this.createInventoryPoint({
                coordinates: event["coordinate"] ?? event["coordinate_"],
                map,
              }),

            icon: <RadioButtonCheckedIcon />,
          },
          {
            label: "polygon",

            action: () => {
              setModeOptions((prev) => ({ ...prev, ADD_POLYGON: [this.uuid] }));
              createNewFeatureLayerToMap({
                map,
                layer: this,
                setEditedGeometry,
              });
            },
            icon: <CropSquareIcon />,
          },
        ],
      },
      ...(modeOptions?.ASBESTOS_CLICK?.includes(this.id)
        ? [
            {
              label: "change_asbestos_presence",
              items: [
                {
                  label: "NOMCA",
                  action: () =>
                    this.changeAsbestosPresence(event, map, "NOMCA"),
                  icon: <CloseIcon />,
                  shortcut: { key: "n", ctrl: true },
                },
                {
                  label: "MPCA",
                  action: () => this.changeAsbestosPresence(event, map, "MPCA"),
                  icon: <QuestionMarkIcon />,
                  shortcut: { key: "p", ctrl: true },
                },
                {
                  label: "MCA",
                  action: () => this.changeAsbestosPresence(event, map, "MCA"),
                  icon: <CheckIcon />,
                  shortcut: { key: "c", ctrl: true },
                },
              ],
            },
          ]
        : []),
    ];
  };

  changeAsbestosPresence = async (event, map, is_asbestos) => {
    const toast_id = toast.info(
      translations[i18n.language].updating_asbestos_presence,
      {
        hideProgressBar: false,
        loading: true,
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );
    let features = await this.getFeatureInfoOnClick(event, map);

    if (features.length > 0) {
      const feature = features[0];
      const item_uuid = feature.properties.uuid;
      const previous_is_asbestos = feature.properties.is_asbestos;
      try {
        update_preliminar_element(item_uuid, this.uuid, {
          is_asbestos: is_asbestos,
        });
        toast.update(toast_id, {
          render: `${translations[i18n.language].asbestos_presence_updated_successfully}: ${translations[i18n.language][is_asbestos]}`,
          type: "success",
          isLoading: false,
          autoClose: 5000,
          closeButton: (
            <UndoButton
              item_uuid={item_uuid}
              layerUuid={this.uuid}
              map={map}
              onClick={async () => {
                Confirm.show(
                  translations[i18n.language].restore_asbestos_presence_title,
                  translations[i18n.language].restore_asbestos_presence_body,
                  translations[i18n.language].yes,
                  translations[i18n.language].no,

                  async () => {
                    const restored_toast_id = toast.loading(
                      translations[i18n.language].restoring_asbestos_presence,
                      {
                        position: "top-right",
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      }
                    );
                    await update_preliminar_element(item_uuid, this.uuid, {
                      is_asbestos: previous_is_asbestos,
                    });
                    toast.update(restored_toast_id, {
                      render: `${translations[i18n.language].asbestos_presence_restored_successfully}: ${translations[i18n.language][previous_is_asbestos]}`,
                      type: "success",
                      isLoading: false,
                      autoClose: 5000,
                    });
                  },
                  () => {},
                  {}
                );
              }}
            />
          ),
        });
      } catch (err) {
        console.error("Error updating asbestos presence:", err);
        toast.update(toast_id, {
          render: translations[i18n.language].error_updating_asbestos_presence,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
        return;
      }
    } else {
      toast.update(toast_id, {
        render: translations[i18n.language].no_element_found,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };
}

export { AsbestosInventoryLayer };
